// ----------------------------------------------------------------------

const account = {
  displayName: 'Aayush Talreja',
  email: 'aayush@jalshuraksha.in',
  photoURL: '/assets/images/avatars/avatar_default.jpg',
};

export default account;
